/* eslint-disable indent */
(function (window) {
	"use strict";
	function defineCastingUtility() {
		var castingUtility = {};
		castingUtility.toBoolean = function (value) {
			if (value === undefined || value === null) {
				return null;
			}
			if (value === true) {
				return true;
			} else if (value === false) {
				return false;
			}

			if(value === 1){
				return true;
			}
			if(value === 0){
				return false;
			}

			switch (value.toLowerCase().trim()) {
				case "true": 
				case "yes": 
				case "1": 
					return true;
				case "false": 
				case "no": 
				case "0": 
				case null: 
					return false;
				default: 
					return Boolean(value);
			}
		};
		castingUtility.booleanToNumber = function(value){
			if(value){
				return 1;
			}
			return 0;
		};
		castingUtility.booleanToString = function(value){
			if (value === true){
				return "Yes";
			}
			if(value === false){
				return "No";
			}

			if(value === 0){
				return "No";
			}
			if(value === 1){
				return "Yes";
			}

			return "No";
		};
		castingUtility.isValueBoolean = function(value){
			if(value === true){
				return true;
			}
			if(value === false){
				return true;
			}
			return false;
		};
		return castingUtility;
	}

	if (typeof (castingUtility) === "undefined") {
		window.castingUtility = defineCastingUtility();
	} else {
		console.log("castingUtility already defined.");
	}
})(window);
